module.exports = __webpack_public_path__ + "static/media/icon_11_Ausschüsse Online für DWA-Präsidium, Vorstand und Beirat_prev.f1bd8e97.png";